// extracted by mini-css-extract-plugin
export default {"container":"src-pages-SalesCannelVersion-SalesChannelLegal-TermsAndConditionEditor-Content-css-module__container--gGj84"};